
import { defineComponent, onMounted, ref, watch } from "vue";
import Rating from "../Rating.vue";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import router from "@/router";
import axios from "axios";
import ReferenceDataApi from "@/core/services/ReferenceDataApi";
import th from "@element-plus/locale/lang/th.js";
import { bu } from "@fullcalendar/core/internal-common";
const userInfo = ref<any>(null);
const modelEdit = ref({
  email: "",
  password: "",
  cpassword: "",
  prefix: "",
  firstName: "",
  lastName: "",
  idCard: "",
  birthDate: "",
  phoneNumber: "",
  regionId: "",
  provinceId: "",
  districtId: "",
  subDistrictId: "",
  provinceTh: "",
  provinceEn: "",
  districtTh: "",
  subDistrictTh: "",
  zipcode: "",
  road: "",
  no: "",
  moo: "",
  soi: "",
  qualificationId: "",
  qualificationOther: "",
  qualificationMajor: "",
  officeTypeId: "",
  officeExperience: "",
  officePosition: "",
  officeJobDesc: "",
  toc: false,
  imageProfile: "",
  file: null,
  type: 1,
});
const modelEditLoaded = ref(false);
const modelMandatory = ref({
  facId: "",
  preFactoryNo: "",
  preBuildingNo: "",
  officeTypeId: "",
  factorySizeId: "",
  factoryTypes: [],
  factoryTypeOther: "",
  buildingSizeId: "",
  buildingTypes: [],
  buildingTypeOther: "",
  companyElectric: "",
  companyTransformer: "",
  companyHeat: "",
  companyFuel: "",
  machines: [],
  machineOther: "",
  technologies: [],
  technologieOther: "",
  warrantorFirstname: "",
  warrantorLastname: "",
  warrantorPosition: "",
  warrantorOffice: "",
  qualificationImage: [],
  faceImage: "",
  delImages: [],
  fileAvatar: null,
  fileImages: [],
  imagesList: [],
  facBuildTypeId: [],
  type: 2,
  becProfType: "",
  cerImage: null as File | null,
  cerImagePreview: "",
});
const factoriesList = ref([]);
const factoryNow = ref({
  address: "",
  addressProfile: {},
  addressFac: {
    no: "",
    moo: "",
    soi: "",
    road: "",
    regionTh: "",
    provinceTh: "",
    districtTh: "",
    subDistrictTh: "",
    zipcode: "",
  },
});
const myCourseList = ref();
const syllabusList = ref();
const search = ref("");
const limit = ref(12);
const page = ref(0);
const totalPage = ref(0);
const listCertificate = ref();
const checkIdcard = ref(true);
const currentAdress = ref();
const dialogError = ref(false);
const showMandatoryTabs = ref(false);
const activeInfoTab = ref("info_1");
const dialogDeleteUser = ref(false);
const dialogDeleteConfirmed = ref(false);
const dialogDeletePopup = ref(false);
const dialogDeletePdpa = ref(false);
const dialogSurvey = ref(false);
const dialogPolicy = ref(false);
const dialogNotification = ref(false);
const surveyCourseId = ref(null);
const surveyOptions = ref([
  { emoji: "😆", label: "มากที่สุด", value: 5 },
  { emoji: "😊", label: "มาก", value: 4 },
  { emoji: "😐", label: "ปานกลาง", value: 3 },
  { emoji: "😟", label: "น้อย", value: 2 },
  { emoji: "😢", label: "น้อยที่สุด", value: 1 },
]);
const currentType =ref(null);
const surveyData = ref({
  q1: null,
  q2: null,
  q3: null,
  q4: null,
  q5: null,
  suggestion: "",
});
const errors = ref<any>({});
const errors2 = ref<any>({});
export default defineComponent({
  name: "profile",
  components: {
    Rating,
  },
  data() {
    return {
      locale: th,
      imageUrl: process.env.VUE_APP_IMG_URL,
      provinceList: [],
      districtList: [],
      subDistrictList: [],
      qualificationList: [],
      officeTypeList: [],
      myCourseSize: 0,
      factoriesList: [],
      buildingSizesList: [],
      buildingTypesList: [],
      technologiesList: [],
      machinesList: [],
      factorySizesList: [],
      factoryTypesList: [],
      factory: {
        addressProfile: {},
      },
      factoryBuildingTypesList: [],
      search: "",
      myCertificateList: [],
      rateId: null,
      rate1: 0,
      rate2: 0,
      rate3: 0,
      rate4: 0,
      localeConfig: {
        lang: th, // Set the language code (e.g., 'en' for English, 'fr' for French, etc.)
      },
      formpassword: false,
      validate: 0,
      oldPassword: "",
      newPassword: "",
      newPasswordConfirm: "",
      validateCpassword: true,
      authEmail: "",
      authEmailValid: false,
      authPassword: "",
      authPasswordConfirm: "",
      authValidate: 0,
      authValidateCpassword: true,
      passwordFieldType: "password",
      passwordFieldType2: "password",
      passwordFieldType3: "password",
      prefixList: [],
      accessToken: null,
      regionList: [],
      listErrorApi: [],
      remarkDeleteUser: "1",
      remarkDeleteOther: "",
      flgPdpaIndex: 0,
    };
  },

  setup() {
    /* eslint-disable */
    const tab1 = ref(false);
    const router = useRouter();
    const route = useRoute();
    const tab = ref();
    onMounted(() => {
      if (localStorage.getItem("id_token") != null) {
        getCourseRegister();
        axios
          .get(
            process.env.VUE_APP_API_URL +
              "/getSyllabusRegister?userId=" +
              localStorage.getItem("u_id"),
            {
              headers: {
                token: localStorage.getItem("id_token"),
              },
            },
          )
          .then((response) => {
            syllabusList.value = response.data.data.content;
            // console.log("syllabusList");
            // console.log(syllabusList.value);
          })
          .catch((error) => {
            // console.log(error);
          });
        axios
          .get(
            process.env.VUE_APP_API_URL +
              "/getProfile?id=" +
              localStorage.getItem("u_id"),
            {
              headers: {
                token: localStorage.getItem("id_token"),
              },
            },
          )
          .then((response) => {
            // console.log("getProfile");
            // console.log(response.data.data);
            userInfo.value = response.data.data;
            modelEdit.value = response.data.data;
            modelEditLoaded.value = true;

            if (
              modelEdit.value["imageProfile"] &&
              modelEdit.value["imageProfile"].indexOf("http") == -1
            ) {
              modelEdit.value["imageProfile"] =
                process.env.VUE_APP_IMG_URL + modelEdit.value["imageProfile"];
            }

            modelEdit.value.birthDate = setDate(modelEdit.value.birthDate) + "";

            // console.log("====================================");
            // console.log(modelEdit.value.birthDate);
            // console.log("====================================");
            modelEdit.value.no = modelEdit.value["address"]
              ? modelEdit.value["address"]["no"]
              : "";
            modelEdit.value.moo = modelEdit.value["address"]
              ? modelEdit.value["address"]["moo"]
              : "";
            modelEdit.value.soi = modelEdit.value["address"]
              ? modelEdit.value["address"]["soi"]
              : "";
            modelEdit.value.road = modelEdit.value["address"]
              ? modelEdit.value["address"]["road"]
              : "";
            modelEdit.value.regionId = modelEdit.value["address"]
              ? modelEdit.value["address"]["regionCode"]
              : "";
            modelEdit.value.provinceId = modelEdit.value["address"]
              ? modelEdit.value["address"]["provinceCode"]
              : "";
            modelEdit.value.districtId = modelEdit.value["address"]
              ? modelEdit.value["address"]["districtCode"]
              : "";
            modelEdit.value.subDistrictId = modelEdit.value["address"]
              ? modelEdit.value["address"]["subDistrictCode"]
              : "";
            modelEdit.value.zipcode = modelEdit.value["address"]
              ? modelEdit.value["address"]["zipcode"]
              : "";
            // specialist
            if (response.data.data.currentSpecialistStatus != 2) {
              dialogNotification.value = true;
            }

            if (response.data.data.specialist) {
              // console.log(response.data.data.specialist);
              modelMandatory.value = response.data.data.specialist;
              currentType.value =  response.data.data["type"]
              if (
                modelEdit.value["currentSpecialistStatus"] == 0 ||
                modelEdit.value["currentSpecialistStatus"] == 1 ||
                modelEdit.value["currentSpecialistStatus"] == 3
              ) {
                showMandatoryTabs.value = true;
                modelMandatory.value.type =
                  response.data.data.requestSpecialistType > 1
                    ? response.data.data.requestSpecialistType
                    : "";
              } else {
                modelMandatory.value.type =
                  response.data.data["type"] != 1
                    ? response.data.data["type"]
                    : "";
                showMandatoryTabs.value = false;
              }
              if (modelMandatory.value.type == 4) {
                factoryNow.value.addressFac.no =
                  modelMandatory.value["addressType4"];
              }
              modelMandatory.value.facId = modelMandatory.value["factoryId"];
              const newfactoryType: any = [];
              if (modelMandatory.value.factoryTypes) {
                for (const loopData of modelMandatory.value.factoryTypes) {
                  newfactoryType.push(loopData["code"]);
                  if (loopData["other"] != "") {
                    modelMandatory.value.factoryTypeOther = loopData["other"];
                  }
                }
              }
              modelMandatory.value.becProfType =
                modelMandatory.value["certType"];
              modelMandatory.value.factoryTypes = newfactoryType;

              const newbuildingType: any = [];
              if (modelMandatory.value.buildingTypes) {
                for (const loopData of modelMandatory.value.buildingTypes) {
                  newbuildingType.push(loopData["code"]);
                  if (loopData["other"] != "") {
                    modelMandatory.value.buildingTypeOther = loopData["other"];
                  }
                }
              }
              modelMandatory.value.buildingTypes = newbuildingType;

              const newmachine: any = [];
              if (modelMandatory.value.machines != null) {
                for (const loopData of modelMandatory.value.machines) {
                  newmachine.push(loopData["code"]);
                  if (loopData["other"] != "") {
                    modelMandatory.value.machineOther = loopData["other"];
                  }
                }
              }
              modelMandatory.value.machines = newmachine;

              const newtechnologie: any = [];
              if (modelMandatory.value.technologies != null) {
                for (const loopData of modelMandatory.value.technologies) {
                  newtechnologie.push(loopData["code"]);
                  if (loopData["other"] != "") {
                    modelMandatory.value.technologieOther = loopData["other"];
                  }
                }
              }
              modelMandatory.value.technologies = newtechnologie;

              const newqualificationImages: any = [];
              const listId: any = [];
              if (modelMandatory.value.qualificationImage) {
                for (const loopData of modelMandatory.value
                  .qualificationImage) {
                  listId.push(loopData);
                  newqualificationImages.push(
                    process.env.VUE_APP_IMG_URL + loopData,
                  );
                }
              }
              modelMandatory.value.qualificationImage = newqualificationImages;
              modelMandatory.value.imagesList = listId;

              if (modelMandatory.value.faceImage != null) {
                modelMandatory.value.faceImage =
                  process.env.VUE_APP_IMG_URL + modelMandatory.value.faceImage;
              }
              if (modelMandatory.value.cerImage != null) {
                modelMandatory.value.cerImagePreview =
                  (process.env.VUE_APP_IMG_URL ?? "") +
                  modelMandatory.value.cerImage;
                modelMandatory.value.cerImage = null;
              }
            }
          })
          .catch((error) => {
            // console.log(error);
            localStorage.removeItem("u_id");
            localStorage.removeItem("id_token");
            localStorage.removeItem("userInfo");
            router.push({ name: "sign-in" });
          });
      } else {
        router.push({ name: "sign-in" });
      }
      if (route.query.tab) {
        tab.value = route.query.tab;
      } else {
        tab.value = 1;
      }
      if (route.hash) {
        setTimeout(() => {
          const el = document.querySelector(
            `a[href="${route.hash}"]`,
          ) as HTMLElement;
          if (el) el.click();
        }, 300);
      }
      // getDocuments();
      // getBookmark();
    });

    watch(
      () => route.query.tab,
      (newValue) => {
        if (newValue) {
          tab.value = newValue;
        } else {
          tab.value = 1;
        }
        router.go(0);
      },
    );
    const setDate = (birthDate) => {
      let date = new Date(modelEdit.value.birthDate);
      let data = "";
      data += date.getDate() + "/";
      if (date.getMonth() + 1 >= 10) {
        data += date.getMonth() + 1 + "/";
      } else {
        data += "0" + (date.getMonth() + 1) + "/";
      }
      data += date.getFullYear();
      // console.log("====================================");
      // console.log(data);
      // console.log("====================================");
      return data;
    };
    const getCourseRegister = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getCourseRegister?userId=" +
            localStorage.getItem("u_id") +
            "&page=" +
            page.value +
            "&sizeContents=" +
            limit.value,
          {
            headers: { token: localStorage.getItem("id_token") },
          },
        )
        .then((response) => {
          myCourseList.value = response.data.data.content;
          myCourseList.value["totalElements"] =
            response.data.data.totalElements;
          totalPage.value = response.data.data.totalPages;
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const changePage = (pageEvent) => {
      page.value = pageEvent - 1;
      getCourseRegister();
    };
    const backPage = () => {
      page.value = page.value - 1;
      getCourseRegister();
    };
    const nextPage = () => {
      page.value = page.value + 1;
      getCourseRegister();
    };
    const searchData = () => {
      page.value = 0;
      getCourseRegister();
    };
    const checkRequire = (tab2) => {
      errors.value = {};
      errors2.value = {};
      if (!modelEdit.value.firstName) errors.value.firstName = "กรุณาระบุชื่อ";
      if (!modelEdit.value.lastName) errors.value.lastName = "กรุณาระบุนามสกุล";
      if (!modelEdit.value.idCard)
        errors.value.idCard = "กรุณาระบุเลขประจำตัวบัตรประชาชน";
      if (checkIdcard.value == false)
        errors.value.idCard = "กรุณาระบุเลขประจำตัวบัตรประชาชนให้ถูกต้อง";
      if (!modelEdit.value.phoneNumber)
        errors.value.phoneNumber = "กรุณาระบุเบอร์โทรศัพท์";
      if (
        modelEdit.value.phoneNumber &&
        modelEdit.value.phoneNumber.length < 10
      )
        errors.value.phoneNumber = "กรุณาระบุเบอร์โทรศัพท์ให้ครบ 10 หลัก";
      if (!modelEdit.value.qualificationId)
        errors.value.qualificationId = "กรุณาระบุคุณวุฒิ";
      if (!modelEdit.value.qualificationMajor)
        errors.value.qualificationMajor = "กรุณาระบุสาขาวิชา";
      if (!modelEdit.value.officeTypeId)
        errors.value.officeTypeId = "กรุณาเลือกประเภทของหน่วยงาน";
      if (!dialogError.value) {
        if (!modelEdit.value.prefix) errors.value.prefix = "กรุณาระบุคำนำหน้า";
        if (!modelEdit.value.no) errors.value.no = "กรุณาระบุเลขที่";
        if (!modelEdit.value.regionId)
          errors.value.regionId = "กรุณาเลือกภาค";
        if (!modelEdit.value.provinceId)
          errors.value.provinceId = "กรุณาเลือกจังหวัด";
        if (!modelEdit.value.districtId)
          errors.value.districtId = "กรุณาเลือกอำเภอ";
        if (!modelEdit.value.subDistrictId)
          errors.value.subDistrictId = "กรุณาเลือกตำบล";
        if (!modelEdit.value.zipcode)
          errors.value.zipcode = "กรุณาระบุรหัสไปรษณีย์";
      }
      if (
        modelEdit.value.email &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(modelEdit.value.email)
      )
        errors.value.email = "กรุณาระบุอีเมลให้ถูกต้อง";

      // Specialist fields (if needed by logic)
      // if (modelMandatory.value.facId != "") {
      //   if (!modelMandatory.value.faceImage)
      //     errors2.value.faceImage = "กรุณาแนบรูปหน้าตรง";
      // }
      if (tab2 == true) {
        if (modelMandatory.value.type == 4) {
          if (!modelMandatory.value.becProfType) {
            errors2.value.becProfType = "กรุณาเลือกประเภทวิชาชีพ";
          }
          if (
            !modelMandatory.value.cerImage &&
            !modelMandatory.value.cerImagePreview
          ) {
            errors2.value.cerImage = "กรุณาแนบใบประกอบวิชาชีพ";
          }
          if (!factoryNow.value.addressFac.no)
            errors2.value.addressNo = "กรุณาระบุที่อยู่ที่ทำงาน";
        }
        if (
          modelMandatory.value.type == 1 ||
          modelMandatory.value.type == 2 ||
          modelMandatory.value.type == 3
        ) {
          if (!modelMandatory.value.facId)
            errors2.value.facId = "กรุณาเลือกชื่อสถานที่ทำงาน";
        }
      }

      if (
        Object.keys(errors.value).length === 0 &&
        Object.keys(errors2.value).length === 0
      ) {
        tab1.value = true;
      } else {
        tab1.value = false;
        Swal.fire({
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          html:
            Object.values(errors.value)
              .map((err) => `<div class="text-start">- ${err}</div>`)
              .join("") +
            Object.values(errors2.value)
              .map((err) => `<div class="text-start">- ${err}</div>`)
              .join(""),
          icon: "warning",
          confirmButtonText: "ตกลง",
        }).then(() => {
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            document.documentElement.scrollTop = 350;
            document.body.scrollTop = 350;
          }, 500);
        });
      }
      if (tab1.value) {
        return true;
      } else {
        return false;
      }
    };
    const onSubmitRegister = async () => {
      Swal.fire({
        title: "กำลังดำเนินการ...",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      if (checkRequire(false)) {
        let birthDate: number | string = "";
        if (modelEdit.value.birthDate) {
          const parts = modelEdit.value.birthDate.split("/");
          const reordered = parts[1] + "/" + parts[0] + "/" + parseInt(parts[2]);
          birthDate = new Date(reordered).getTime();
        }
        const formData = new FormData();
        formData.append("id ", modelEdit.value["id"]);
        formData.append("type", String(modelEdit.value["type"]));
        formData.append(
          "prefix ",
          modelEdit.value.prefix != null ? modelEdit.value.prefix : "",
        );
        formData.append(
          "firstName",
          modelEdit.value.firstName != null ? modelEdit.value.firstName : "",
        );
        formData.append(
          "lastName",
          modelEdit.value.lastName != null ? modelEdit.value.lastName : "",
        );
        formData.append(
          "idCard",
          modelEdit.value.idCard != null ? modelEdit.value.idCard : "",
        );
        formData.append("birthDate", String(birthDate));
        formData.append("regionCode", modelEdit.value.regionId);
        formData.append(
          "regionTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.region_c
            : "",
        );
        formData.append("provinceCode", modelEdit.value.provinceId);
        formData.append(
          "provinceTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.province_th
            : "",
        );
        formData.append(
          "provinceEn",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.province_en
            : "",
        );
        formData.append("districtCode", modelEdit.value.districtId);
        formData.append(
          "districtTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.city_th
            : "",
        );
        formData.append("subDistrictCode", modelEdit.value.subDistrictId);
        formData.append(
          "subDistrictTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.sub_district_name_th
            : "",
        );
        formData.append(
          "zipcode",
          modelEdit.value.zipcode != null && modelEdit.value.zipcode != "null"
            ? modelEdit.value.zipcode
            : "",
        );
        formData.append(
          "road",
          modelEdit.value.road != null && modelEdit.value.road != "null"
            ? modelEdit.value.road
            : "",
        );
        formData.append(
          "no",
          modelEdit.value.no != null && modelEdit.value.no != "null"
            ? modelEdit.value.no
            : "",
        );
        formData.append(
          "moo",
          modelEdit.value.moo != null && modelEdit.value.moo != "null"
            ? modelEdit.value.moo
            : "",
        );
        formData.append(
          "soi",
          modelEdit.value.soi != null && modelEdit.value.soi != "null"
            ? modelEdit.value.soi
            : "",
        );
        formData.append(
          "phoneNumber",
          modelEdit.value.phoneNumber != null &&
            modelEdit.value.phoneNumber != "null"
            ? modelEdit.value.phoneNumber
            : "",
        );
        formData.append("qualificationId", modelEdit.value.qualificationId);
        formData.append(
          "qualificationOther",
          modelEdit.value.qualificationOther != null
            ? modelEdit.value.qualificationOther
            : "",
        );
        formData.append(
          "qualificationMajor",
          modelEdit.value.qualificationMajor != null
            ? modelEdit.value.qualificationMajor
            : "",
        );
        formData.append(
          "officeTypeId",
          modelEdit.value.officeTypeId != null
            ? modelEdit.value.officeTypeId
            : "",
        );
        formData.append(
          "officeExperience",
          modelEdit.value.officeExperience != null
            ? modelEdit.value.officeExperience
            : "",
        );
        formData.append(
          "officePosition",
          modelEdit.value.officePosition != null
            ? modelEdit.value.officePosition
            : "",
        );
        formData.append(
          "officeJobDesc",
          modelEdit.value.officeJobDesc != null
            ? modelEdit.value.officeJobDesc
            : "",
        );

        /* eslint-disable */
        if (modelEdit.value.file != null) {
          const formUploadImage = new FormData();
          formUploadImage.append("file ", modelEdit.value.file!);
          let uploadImage = await axios.post(
            process.env.VUE_APP_API_URL + "/uploadImage",
            formUploadImage,
            { headers: { token: localStorage.getItem("id_token") } },
          );
          // console.log(uploadImage);

          formData.append("imageProfile", uploadImage.data.data!);
        }
        axios
          .post(process.env.VUE_APP_API_URL + "/editProfile", formData, {
            headers: { token: localStorage.getItem("id_token") },
          })
          .then((res) => {
            if (res.data.code == 200) {
              const jsonUser = JSON.stringify({
                email: res.data.data.email,
                firstName: res.data.data.firstName,
                lastName: res.data.data.lastName,
                imageProfile: res.data.data.imageProfile,
              });
              localStorage.setItem("userInfo", jsonUser);
              if (modelMandatory.value.facId != "") {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                saveMandatory();
              } else {
                Swal.fire({
                  title: "บันทึกรายการสำเร็จ",
                  text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "ตกลง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-primary",
                  },
                }).then(function(res) {
                  router.go(0);
                });
              }
            } else {
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: res.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: error.response.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          });
      }
    };
    const onSubmitSpecialist = async () => {
      Swal.fire({
        title: "กำลังดำเนินการ...",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });

      if (checkRequire(true)) {
        let birthDate: number | string = "";
        if (modelEdit.value.birthDate) {
          const parts = modelEdit.value.birthDate.split("/");
          const reordered = parts[1] + "/" + parts[0] + "/" + parseInt(parts[2]);
          birthDate = new Date(reordered).getTime();
        }
        const formData = new FormData();
        formData.append("id ", modelEdit.value["id"]);
        formData.append("type", String(modelEdit.value["type"]));
        formData.append(
          "prefix ",
          modelEdit.value.prefix != null ? modelEdit.value.prefix : "",
        );
        formData.append(
          "firstName",
          modelEdit.value.firstName != null ? modelEdit.value.firstName : "",
        );
        formData.append(
          "lastName",
          modelEdit.value.lastName != null ? modelEdit.value.lastName : "",
        );
        formData.append(
          "idCard",
          modelEdit.value.idCard != null ? modelEdit.value.idCard : "",
        );

        formData.append("birthDate", String(birthDate));
        formData.append("regionCode", modelEdit.value.regionId);
        formData.append(
          "regionTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.region_c
            : "",
        );
        formData.append("provinceCode", modelEdit.value.provinceId);
        formData.append(
          "provinceTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.province_th
            : "",
        );
        formData.append(
          "provinceEn",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.province_en
            : "",
        );
        formData.append("districtCode", modelEdit.value.districtId);
        formData.append(
          "districtTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.city_th
            : "",
        );
        formData.append("subDistrictCode", modelEdit.value.subDistrictId);
        formData.append(
          "subDistrictTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.sub_district_name_th
            : "",
        );
        formData.append(
          "zipcode",
          modelEdit.value.zipcode != null ? modelEdit.value.zipcode : "",
        );
        console.log("formData", formData);

        formData.append(
          "road",
          modelEdit.value.road != null && modelEdit.value.road != "null"
            ? modelEdit.value.road
            : "",
        );
        formData.append(
          "no",
          modelEdit.value.no != null && modelEdit.value.no != "null"
            ? modelEdit.value.no
            : "",
        );
        formData.append(
          "moo",
          modelEdit.value.moo != null && modelEdit.value.moo != "null"
            ? modelEdit.value.moo
            : "",
        );
        formData.append(
          "soi",
          modelEdit.value.soi != null && modelEdit.value.soi != "null"
            ? modelEdit.value.soi
            : "",
        );
        formData.append(
          "phoneNumber",
          modelEdit.value.phoneNumber != null &&
            modelEdit.value.phoneNumber != "null"
            ? modelEdit.value.phoneNumber
            : "",
        );
        formData.append("qualificationId", modelEdit.value.qualificationId);
        formData.append(
          "qualificationOther",
          modelEdit.value.qualificationOther != null
            ? modelEdit.value.qualificationOther
            : "",
        );
        formData.append(
          "qualificationMajor",
          modelEdit.value.qualificationMajor != null
            ? modelEdit.value.qualificationMajor
            : "",
        );
        formData.append(
          "officeTypeId",
          modelEdit.value.officeTypeId != null
            ? modelEdit.value.officeTypeId
            : "",
        );
        formData.append(
          "officeExperience",
          modelEdit.value.officeExperience != null
            ? modelEdit.value.officeExperience
            : "",
        );
        formData.append(
          "officePosition",
          modelEdit.value.officePosition != null
            ? modelEdit.value.officePosition
            : "",
        );
        formData.append(
          "officeJobDesc",
          modelEdit.value.officeJobDesc != null
            ? modelEdit.value.officeJobDesc
            : "",
        );
        /* eslint-disable */
        if (modelEdit.value.file != null) {
          const formUploadImage = new FormData();
          formUploadImage.append("file ", modelEdit.value.file!);
          let uploadImage = await axios.post(
            process.env.VUE_APP_API_URL + "/uploadImage",
            formUploadImage,
            { headers: { token: localStorage.getItem("id_token") } },
          );
          // console.log(uploadImage);

          formData.append("imageProfile", uploadImage.data.data!);
        }
        axios
          .post(process.env.VUE_APP_API_URL + "/editProfile", formData, {
            headers: { token: localStorage.getItem("id_token") },
          })
          .then((res) => {
            if (res.data.code == 200) {
              const jsonUser = JSON.stringify({
                email: res.data.data.email,
                firstName: res.data.data.firstName,
                lastName: res.data.data.lastName,
                imageProfile: res.data.data.imageProfile,
              });
              localStorage.setItem("userInfo", jsonUser);
              saveMandatoryTrue();
              // if (modelMandatory.value.facId != "") {
              //   // eslint-disable-next-line @typescript-eslint/no-use-before-define
              //   saveMandatoryTrue();
              // } else {
              //   Swal.fire({
              //     title: "บันทึกรายการสำเร็จ",
              //     text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
              //     icon: "success",
              //     buttonsStyling: false,
              //     confirmButtonText: "ตกลง!",
              //     customClass: {
              //       confirmButton: "btn fw-semobold btn-light-primary",
              //     },
              //   }).then(function(res) {
              //     router.go(0);
              //   });
              // }
            } else {
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: res.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: error.response.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          });
      }
    };

    /* eslint-disable */
    const saveMandatory = () => {
      const factoryTypes: any = [];
      for (const loopFactory of modelMandatory.value.factoryTypes) {
        if (loopFactory != undefined) {
          factoryTypes.push({
            code: loopFactory,
            other:
              loopFactory == "10" ? modelMandatory.value.factoryTypeOther : "",
          });
        }
      }

      const buildingTypes: any = [];
      for (const loopBuild of modelMandatory.value.buildingTypes) {
        if (loopBuild != undefined) {
          buildingTypes.push({
            code: loopBuild,
            other:
              loopBuild == "6" ? modelMandatory.value.buildingTypeOther : "",
          });
        }
      }

      const machinesMap: any = [];
      if (modelMandatory.value.machines != null) {
        for (const loopMachine of modelMandatory.value.machines) {
          if (loopMachine != undefined) {
            machinesMap.push({
              code: loopMachine,
              other:
                loopMachine == "6" ? modelMandatory.value.machineOther : "",
            });
          }
        }
      }

      let technologiesMap: any = [];
      if (modelMandatory.value.technologies != null) {
        for (const loopTech of modelMandatory.value.technologies) {
          if (loopTech != undefined) {
            technologiesMap.push({
              code: loopTech,
              other:
                loopTech == "6" ? modelMandatory.value.technologieOther : "",
            });
          }
        }
      }

      const formData = new FormData();
      formData.append("requestSpecialist", "false");
      formData.append("factoryId", modelMandatory.value.facId);
      formData.append(
        "preFactoryNo",
        modelMandatory.value.preFactoryNo != null
          ? modelMandatory.value.preFactoryNo
          : "",
      );
      formData.append(
        "preBuildingNo",
        modelMandatory.value.preBuildingNo != null
          ? modelMandatory.value.preBuildingNo
          : "",
      );
      formData.append(
        "officeTypeId",
        modelMandatory.value.officeTypeId != null
          ? modelMandatory.value.officeTypeId
          : "",
      );
      formData.append(
        "factorySizeId",
        modelMandatory.value.factorySizeId != null
          ? modelMandatory.value.factorySizeId
          : "",
      );
      formData.append("factoryTypes", JSON.stringify(factoryTypes));
      formData.append(
        "buildingSizeId",
        modelMandatory.value.buildingSizeId != null
          ? modelMandatory.value.buildingSizeId
          : "",
      );
      formData.append("buildingTypes", JSON.stringify(buildingTypes));
      formData.append("companyElectric", modelMandatory.value.companyElectric);
      formData.append(
        "companyTransformer",
        modelMandatory.value.companyTransformer,
      );
      formData.append("companyHeat", modelMandatory.value.companyHeat);
      formData.append("companyFuel", modelMandatory.value.companyFuel);
      formData.append("machines", JSON.stringify(machinesMap));
      formData.append("technologies", JSON.stringify(technologiesMap));
      formData.append(
        "warrantorFirstname",
        modelMandatory.value.warrantorFirstname,
      );
      formData.append(
        "warrantorLastname",
        modelMandatory.value.warrantorLastname,
      );
      formData.append(
        "warrantorPosition",
        modelMandatory.value.warrantorPosition,
      );
      formData.append("warrantorOffice", modelMandatory.value.warrantorOffice);
      formData.append("type", modelMandatory.value.type + "");
      formData.append("certType", modelMandatory.value.becProfType + "");
      if (modelMandatory.value.fileImages) {
        for (const loopfile of modelMandatory.value.fileImages) {
          formData.append("qualificationImage", loopfile);
        }
      }
      /* eslint-disable */
      if (modelMandatory.value.fileAvatar != null) {
        formData.append("faceImage", modelMandatory.value.fileAvatar!);
      }
      if (modelMandatory.value.cerImage != null) {
        formData.append("cerImage", modelMandatory.value.cerImage!);
      }
      if (modelMandatory.value.delImages) {
        for (const loopfile of modelMandatory.value.delImages) {
          formData.append("deleteQualificationImage", loopfile);
        }
      }
      if (modelMandatory.value.type == 4) {
        formData.append("addressType4", factoryNow.value.addressFac.no);
      } else {
        formData.append("addressType4", "");
      }
      axios
        .post(process.env.VUE_APP_API_URL + "/editSpecialist", formData, {
          headers: { token: localStorage.getItem("id_token") },
        })
        .then((res) => {
          if (res.data.code == 200) {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function(res) {
              router.go(0);
            });
          } else {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function() {
              router.go(-1);
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const saveMandatoryTrue = () => {
      const factoryTypes: any = [];
      for (const loopFactory of modelMandatory.value.factoryTypes) {
        if (loopFactory != undefined) {
          factoryTypes.push({
            code: loopFactory,
            other:
              loopFactory == "10" ? modelMandatory.value.factoryTypeOther : "",
          });
        }
      }

      const buildingTypes: any = [];
      for (const loopBuild of modelMandatory.value.buildingTypes) {
        if (loopBuild != undefined) {
          buildingTypes.push({
            code: loopBuild,
            other:
              loopBuild == "6" ? modelMandatory.value.buildingTypeOther : "",
          });
        }
      }

      let machinesMap: any = [];
      if (modelMandatory.value.machines != null) {
        for (const loopMachine of modelMandatory.value.machines) {
          if (loopMachine != undefined) {
            machinesMap.push({
              code: loopMachine,
              other:
                loopMachine == "6" ? modelMandatory.value.machineOther : "",
            });
          }
        }
      }

      let technologiesMap: any = [];
      if (modelMandatory.value.technologies != null) {
        for (const loopTech of modelMandatory.value.technologies) {
          if (loopTech != undefined) {
            technologiesMap.push({
              code: loopTech,
              other:
                loopTech == "6" ? modelMandatory.value.technologieOther : "",
            });
          }
        }
      }

      const formData = new FormData();
      formData.append("requestSpecialist", currentType.value && currentType.value == modelMandatory.value.type ? "false" : "true");
      formData.append("factoryId", modelMandatory.value.facId);
      formData.append(
        "preFactoryNo",
        modelMandatory.value.preFactoryNo != null
          ? modelMandatory.value.preFactoryNo
          : "",
      );
      formData.append(
        "preBuildingNo",
        modelMandatory.value.preBuildingNo != null
          ? modelMandatory.value.preBuildingNo
          : "",
      );
      formData.append(
        "officeTypeId",
        modelMandatory.value.officeTypeId != null
          ? modelMandatory.value.officeTypeId
          : "",
      );
      formData.append(
        "factorySizeId",
        modelMandatory.value.factorySizeId != null
          ? modelMandatory.value.factorySizeId
          : "",
      );
      formData.append("factoryTypes", JSON.stringify(factoryTypes));
      formData.append(
        "buildingSizeId",
        modelMandatory.value.buildingSizeId != null
          ? modelMandatory.value.buildingSizeId
          : "",
      );
      formData.append("buildingTypes", JSON.stringify(buildingTypes));
      formData.append("companyElectric", modelMandatory.value.companyElectric);
      formData.append(
        "companyTransformer",
        modelMandatory.value.companyTransformer,
      );
      formData.append(
        "companyHeat",
        modelMandatory.value.companyHeat != null
          ? modelMandatory.value.companyHeat
          : "",
      );
      formData.append(
        "companyFuel",
        modelMandatory.value.companyFuel != null
          ? modelMandatory.value.companyFuel
          : "",
      );
      formData.append("machines", JSON.stringify(machinesMap));
      formData.append("technologies", JSON.stringify(technologiesMap));
      formData.append(
        "warrantorFirstname",
        modelMandatory.value.warrantorFirstname,
      );
      formData.append(
        "warrantorLastname",
        modelMandatory.value.warrantorLastname,
      );
      formData.append(
        "warrantorPosition",
        modelMandatory.value.warrantorPosition,
      );
      formData.append("warrantorOffice", modelMandatory.value.warrantorOffice);
      formData.append("type", modelMandatory.value.type + "");
      formData.append("certType", modelMandatory.value.becProfType + "");
      if (modelMandatory.value.fileImages) {
        for (const loopfile of modelMandatory.value.fileImages) {
          formData.append("qualificationImage", loopfile);
        }
      }
      /* eslint-disable */
      if (modelMandatory.value.fileAvatar != null) {
        formData.append("faceImage", modelMandatory.value.fileAvatar!);
      }
      if (modelMandatory.value.cerImage != null) {
        formData.append("cerImage", modelMandatory.value.cerImage!);
      }
      if (modelMandatory.value.delImages) {
        for (const loopfile of modelMandatory.value.delImages) {
          formData.append("deleteQualificationImage", loopfile);
        }
      }
      if (modelMandatory.value.type == 4) {
        formData.append("addressType4", factoryNow.value.addressFac.no);
      } else {
        formData.append("addressType4", "");
      }
      axios
        .post(process.env.VUE_APP_API_URL + "/editSpecialist", formData, {
          headers: { token: localStorage.getItem("id_token") },
        })
        .then((res) => {
          if (res.data.code == 200) {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "กรุณารอการอนุมัติข้อมูลจากแอดมิน",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function(res) {
              router.go(0);
            });
          } else {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function() {
              router.go(-1);
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const callFactories = async (val) => {
      // console.log(val);
      if (val.length > 2) {
        const factories = await axios.get(
          process.env.VUE_APP_API_URL +
            `/getFactory?sizeContents=100&keyWord=${val}`,
          {
            headers: { token: localStorage.getItem("id_token") },
          },
        );
        // console.log(factories.data.data.content);
        factoriesList.value = factories.data.data.content;
      }
    };
    const clearFactory = () => {
      modelMandatory.value.facId = "";
      modelMandatory.value.factoryTypes = [];
      modelMandatory.value.buildingTypes = [];
      modelMandatory.value.facBuildTypeId = [];
      search.value = "";
      factoriesList.value = [];
      factoryNow.value = {
        address: "",
        addressProfile: {},
        addressFac: {
          no: "",
          moo: "",
          soi: "",
          road: "",
          regionTh: "",
          provinceTh: "",
          districtTh: "",
          subDistrictTh: "",
          zipcode: "",
        },
      };
    };
    const callFactoriesId = async () => {
      modelMandatory.value.factoryTypes = [];
      modelMandatory.value.buildingTypes = [];
      const factory = await axios.get(
        process.env.VUE_APP_API_URL +
          `/getFactory?facId=${modelMandatory.value.facId}`,
        {
          headers: { token: localStorage.getItem("id_token") },
        },
      );
      // console.log(factory.data.data);
      const factoryData = factory.data.data.content[0];
      if (!factoryData) return;
      if (!factoryData["addressFac"]) {
        factoryData["addressFac"] = {
          no: "",
          moo: "",
          soi: "",
          road: "",
          regionTh: "",
          provinceTh: "",
          districtTh: "",
          subDistrictTh: "",
          zipcode: "",
        };
      }
      factoryNow.value = factoryData;
      search.value = factoryNow.value["factoryName"];
      let facBuildTypeId: any = [];
      facBuildTypeId.push(factoryNow.value["facBuildTypeId"]);
      // console.log(factoryNow.value["facBuildTypeId"]);
      if (factoryNow.value["type"] == "โรงงาน") {
        modelMandatory.value.facBuildTypeId = facBuildTypeId;
      } else {
        modelMandatory.value.facBuildTypeId = facBuildTypeId;
      }
      // modelMandatory.value.factoryTypes
      callFactories(search.value);
    };
    const getCertificateId = async (id) => {
      // เปิดหน้าต่างทันทีขณะยังอยู่ใน user gesture ป้องกัน popup blocker บน iOS Safari
      const certWindow = window.open("", "_blank");
      let checkSurvey = await axios.get(
        process.env.VUE_APP_API_URL + "/checkCertApproveSurvey",
        {
          headers: { token: localStorage.getItem("id_token") },
        },
      );
      console.log("checkSurvey", checkSurvey.data.data, checkSurvey.data.code);
      if (checkSurvey.data.code == 400) {
        if (certWindow) certWindow.close();
        dialogSurvey.value = true;
        console.log("getCertificateId", dialogSurvey.value);
        surveyCourseId.value = id;
        surveyData.value = {
          q1: null,
          q2: null,
          q3: null,
          q4: null,
          q5: null,
          suggestion: "",
        };
      } else {
        proceedDownloadCertificate(id, certWindow);
      }
    };
    const proceedDownloadCertificate = async (id, certWindow: any = null) => {
      const certificate = await axios.get(
        process.env.VUE_APP_API_URL +
          "/getCourseRegister?id=" +
          id +
          "&userId=" +
          localStorage.getItem("u_id"),
        {
          headers: { token: localStorage.getItem("id_token") },
        },
      );
      listCertificate.value = certificate.data.data.content[0];
      downloadCertificate(id, certWindow);
    };
    const submitSurvey = async () => {
      // เปิดหน้าต่างทันทีขณะยังอยู่ใน user gesture ป้องกัน popup blocker บน iOS Safari
      const certWindow = window.open("", "_blank");
      let fromData = new FormData();
      fromData.append("q1", surveyData.value.q1 + "");
      fromData.append("q2", surveyData.value.q2 + "");
      fromData.append("q3", surveyData.value.q3 + "");
      fromData.append("q4", surveyData.value.q4 + "");
      fromData.append("q5", surveyData.value.q5 + "");
      fromData.append("q6", surveyData.value.suggestion);
      await axios.post(
        process.env.VUE_APP_API_URL + "/addEditCertApproveSurvey",
        fromData,
        {
          headers: {
            token: localStorage.getItem("id_token"),
            "Content-Type": "multipart/form-data",
          },
        },
      );
      console.log("Survey submitted:", surveyData.value);
      dialogSurvey.value = false;
      proceedDownloadCertificate(surveyCourseId.value, certWindow);
    };
    const getCertificateSyllabusId = async (id) => {
      Swal.fire({
        title: "กำลังดาวน์โหลดใบประกาศนียบัตร",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getSyllabusCertPdf?syllabusRegisterId=" +
            id,
          {
            headers: { token: localStorage.getItem("id_token") },
          },
        )
        .then((response) => {
          const content = response.data.data.content;
          if (content?.length > 0 && content[0].certificate) {
            window.open(
              process.env.VUE_APP_IMG_URL + content[0].certificate,
              "_blank",
            );
            Swal.close();
          } else {
            Swal.fire({
              title: "ไม่พบใบประกาศนียบัตร",
              text: "กรุณาลองใหม่อีกครั้ง",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.response?.data?.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const downloadCertificate = async (id, certWindow: any = null) => {
      // ถ้ายังไม่มีหน้าต่างที่เปิดไว้จาก user gesture (เช่น มาจากฟอร์มแบบสำรวจ) ให้เปิดตอนนี้
      if (!certWindow) {
        certWindow = window.open("", "_blank");
      }
      Swal.fire({
        title: "กำลังดาวน์โหลดใบประกาศนียบัตร",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/downloadCertificateCourse?courseRegisterId=" +
            id,
          {
            headers: { token: localStorage.getItem("id_token") },
            responseType: "blob", // กำหนดให้รับข้อมูลเป็น Blob
          },
        )
        .then(async (res) => {
          console.log(res);

          if (res.data) {
            const contentDisposition = res.headers["content-disposition"];
            const fileName = contentDisposition
              ? contentDisposition.split("filename=")[1]
              : "certificate.pdf";

            // ตรวจสอบเนื้อหาในกรณีเกิดข้อผิดพลาด
            if (res.data.type === "application/json") {
              const text = await res.data.text();
              const errorData = JSON.parse(text);
              console.error("Error downloading PDF:", errorData.message);
              if (certWindow) certWindow.close();
              Swal.fire({
                title: "ดาวน์โหลดไฟล์ไม่สำเร็จ",
                text: "กรุณาลองใหม่อีกครั้ง",
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "ตกลง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-primary",
                },
              });
              return;
            }

            // สร้าง Blob URL แล้วนำหน้าต่างที่เปิดไว้ตั้งแต่ตอน user gesture ไปที่ URL นั้น
            // (iOS Safari บล็อก window.open ที่เรียกหลัง await/.then เพราะไม่ถือเป็น user gesture แล้ว)
            const url = window.URL.createObjectURL(
              new Blob([res.data], { type: "application/pdf" }),
            );
            if (certWindow) {
              certWindow.location.href = url;
            } else {
              window.open(url, "_blank");
            }
            Swal.close();
          } else {
            if (certWindow) certWindow.close();
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          if (certWindow) certWindow.close();
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const assertThaiId = (thaiId: string): boolean => {
      // console.log("assertThaiId : " + thaiId);
      const m = thaiId.match(/(\d{12})(\d)/);
      if (!m) {
        console.warn("Bad input from user, invalid thaiId=", thaiId);
        throw new Error("thai-id-must-be-13-digits");
      }
      const digits = m[1].split("");
      const sum = digits.reduce((total: number, digit: string, i: number) => {
        return total + (13 - i) * +digit;
      }, 0);
      const lastDigit = `${(11 - (sum % 11)) % 10}`;
      const inputLastDigit = m[2];
      if (lastDigit !== inputLastDigit) {
        console.warn("Bad input from user, invalid checksum thaiId=", thaiId);
        // throw new Error("thai-id-checksum-mismatched");
        checkIdcard.value = false;
        return false;
      } else {
        checkIdcard.value = true;
        return true;
      }
    };
    const arabic_to_thai = (text) => {
      let data = text
        .replaceAll("1", "๑")
        .replaceAll("2", "๒")
        .replaceAll("3", "๓")
        .replaceAll("4", "๔")
        .replaceAll("5", "๕")
        .replaceAll("6", "๖")
        .replaceAll("7", "๗")
        .replaceAll("8", "๘")
        .replaceAll("9", "๙")
        .replaceAll("0", "๐");
      return data;
    };
    const updatePdpaAllowed = async (flg) => {
      try {
        const response = await axios.post(
          process.env.VUE_APP_API_URL + "/updatePdpaAllowed?pdpaAllowed=" + flg,
          null,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        );
        console.log(response.data);

        if (response.data.code == 200) {
          dialogPolicy.value = false;
          dialogDeletePdpa.value = false;
          userInfo.value.pdpaAllowed = flg == "true";
          if (flg == "false") {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "คุณได้ยกเลิกความยินยอมในการเก็บข้อมูลส่วนบุคคลแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function(res) {
              router.go(0);
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    return {
      route,
      userInfo,
      modelEdit,
      modelEditLoaded,
      onSubmitRegister,
      checkRequire,
      modelMandatory,
      saveMandatory,
      saveMandatoryTrue,
      onSubmitSpecialist,
      tab,
      callFactoriesId,
      clearFactory,
      callFactories,
      search,
      factoriesList,
      factoryNow,
      myCourseList,
      syllabusList,
      getCourseRegister,
      getCertificateId,
      listCertificate,
      downloadCertificate,
      tab1,
      getCertificateSyllabusId,
      assertThaiId,
      checkIdcard,
      arabic_to_thai,
      changePage,
      backPage,
      nextPage,
      searchData,
      limit,
      page,
      totalPage,
      currentAdress,
      dialogError,
      dialogDeleteUser,
      dialogDeleteConfirmed,
      dialogDeletePopup,
      dialogDeletePdpa,
      dialogSurvey,
      surveyOptions,
      surveyData,
      submitSurvey,
      dialogPolicy,
      dialogNotification,
      updatePdpaAllowed,
      errors,
      errors2,
      showMandatoryTabs,
      activeInfoTab,
      currentType
    };
  },
  computed: {
    needSetupAuth() {
      // รอจนกว่า modelEdit จะถูก set จาก API ก่อน ค่อยประเมิน
      if (!(this as any).modelEditLoaded) return false;
      const m: any = (this as any).modelEdit;
      if (!m) return false;
      const hasEmail =
        m.email && String(m.email).trim() !== "" && m.email != null;
      const hasIdCard = m.idCard && String(m.idCard).trim() !== "";
      return !hasEmail && hasIdCard;
    },
  },
  methods: {
    onMandatoryTypeChange(val: number) {
      if (val === 4) {
        (this as any).clearFactory();
        (this as any).errors2.addressNo = "";
      } else {
        (this as any).errors2.facId = "";
      }
    },
    validateAuthEmail() {
      this.authEmail = (this.authEmail || "").replace(/[฀-๿]/g, "");
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.authEmailValid = emailRegex.test(this.authEmail || "");
    },
    validateAuthPassword() {
      this.authValidate = 0;
      const letterRegex = /[a-zA-Z]/;
      const numberRegex = /[0-9]/;
      const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/;
      const pwd = this.authPassword || "";
      if (pwd.length >= 8) this.authValidate++;
      if (letterRegex.test(pwd)) this.authValidate++;
      if (numberRegex.test(pwd)) this.authValidate++;
      if (symbolRegex.test(pwd)) this.authValidate++;
      this.validateAuthConfirm();
    },
    validateAuthConfirm() {
      this.authValidateCpassword =
        this.authPasswordConfirm === "" ||
        this.authPassword === this.authPasswordConfirm;
    },
    async submitUserAuth() {
      this.validateAuthEmail();
      if (
        !this.authEmail ||
        !this.authEmailValid ||
        this.authValidate !== 4 ||
        this.authPassword !== this.authPasswordConfirm
      ) {
        Swal.fire({
          title: "ข้อมูลไม่ครบถ้วน",
          text: "กรุณากรอกอีเมลและรหัสผ่านให้ถูกต้องตามเงื่อนไข",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-warning",
          },
        });
        return;
      }
      const formData = new FormData();
      formData.append("email", this.authEmail);
      formData.append("userName", this.authEmail);
      formData.append("password", this.authPassword);
      await axios
        .post(process.env.VUE_APP_API_URL + "/updateUserAuth", formData, {
          headers: { token: localStorage.getItem("id_token") },
        })
        .then((res) => {
          if (res.data.code == 200) {
            Swal.fire({
              title: "บันทึกสำเร็จ",
              text: "ตั้งชื่อผู้ใช้งานและรหัสผ่านเรียบร้อยแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(() => {
              this.authEmail = "";
              this.authPassword = "";
              this.authPasswordConfirm = "";
              this.authValidate = 0;
              this.$router.go(0);
            });
          } else {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    validateThai(input, value) {
      const thaiRegex = /^[\u0E00-\u0E7F]+$/;
      let check = thaiRegex.test(value);
      if (input == "firstName" && check != true) {
        modelEdit.value.firstName = "";
      }
      if (input == "lastName" && check != true) {
        modelEdit.value.lastName = "";
      }
    },
    formatDate(date) {
      const event = new Date(date);
      let dateString =
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }) + "";
      return dateString;
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    switchVisibility2() {
      this.passwordFieldType2 =
        this.passwordFieldType2 === "password" ? "text" : "password";
    },
    switchVisibility3() {
      this.passwordFieldType3 =
        this.passwordFieldType3 === "password" ? "text" : "password";
    },

    setAltImg(event) {
      event.target.src = "media/avatars/blank.png";
    },
    setAltImgCover(event) {
      event.target.src = "media/image-app/no-data.svg";
    },
    removeStyle(html) {
      const regex = /(style=".+?")/gm;
      const str = html;
      const subst = ``;
      const result = str.replace(regex, subst);
      return result;
    },
    onFileChange(event) {
      modelEdit.value.file = event.target.files[0];
      modelEdit.value.imageProfile = URL.createObjectURL(event.target.files[0]);
    },
    onFileChangeMultiple(event) {
      const deleteFile: any = [];
      if (modelMandatory.value.imagesList) {
        for (const loopDel of modelMandatory.value.imagesList) {
          deleteFile.push(loopDel);
        }
      }
      modelMandatory.value.delImages = deleteFile;
      modelMandatory.value.fileImages = event.target.files;
      if (event.target.files.length > 0 || event.target.files.length == 3) {
        const image: any = [];
        for (const loopFile of event.target.files) {
          image.push(URL.createObjectURL(loopFile));
        }
        modelMandatory.value.qualificationImage = image;
      } else {
        Swal.fire({
          title: "แจ้งเตือนข้อผิดพลาด",
          text: "จำนวนรูปไม่ถูกต้อง แนบไฟล์จำนวน 3 ไฟล์",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }
    },
    onFileChangeAvatar(event) {
      modelMandatory.value.fileAvatar = event.target.files[0];
      modelMandatory.value.faceImage = URL.createObjectURL(
        event.target.files[0],
      );
    },
    onFileChangeCerImage(event) {
      const file = event.target.files[0];
      if (!file) return;
      modelMandatory.value.cerImage = file;
      modelMandatory.value.cerImagePreview = URL.createObjectURL(file);
    },
    fileCerImageClick() {
      (this.$refs.fileCerImage as HTMLInputElement).click();
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      // eslint-disable-next-line prefer-const
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    async callProvince(regionId, clear) {
      if (clear == true) {
        modelEdit.value.provinceId = "";
        modelEdit.value.districtId = "";
        modelEdit.value.subDistrictId = "";
        modelEdit.value.zipcode = "";
      }
      const provinces = await ReferenceDataApi.getProvinces();
      this.provinceList = (provinces.data.data || []).filter(
        (p) => p.region_code == regionId,
      );
    },
    async callDistrict(provinceId, clear) {
      if (clear == true) {
        modelEdit.value.districtId = "";
        modelEdit.value.subDistrictId = "";
        modelEdit.value.zipcode = "";
      }
      const districts = await ReferenceDataApi.getDistricts(provinceId);
      this.districtList = districts.data.data;
    },
    async callSubDistrict(districtId, clear) {
      if (clear == true) {
        modelEdit.value.subDistrictId = "";
        modelEdit.value.zipcode = "";
      }
      try {
        let response = await ReferenceDataApi.getSubDistricts(
          modelEdit.value.provinceId,
          districtId,
        );
        this.subDistrictList = response.data.data;
      } catch (error) {
        (this.listErrorApi as any).push({
          api: process.env.VUE_APP_API_URL + "/getReferenceSubDistricts",
          message: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
        });
      }
    },
    callZipcode(subDistrictId, clear) {
      if (clear == true) {
        modelEdit.value.zipcode = "";
      }
      if (this.subDistrictList.length > 0) {
        for (const loopData of this.subDistrictList) {
          if (loopData["sub_district_code"] == subDistrictId) {
            currentAdress.value = loopData;
            modelEdit.value.zipcode = loopData["postcode"];
          }
        }
      }
    },

    // async callFactories() {
    //   const factories = await axios.get(
    //     process.env.VUE_APP_API_URL + `/getFactory?sizeContents=99999&keyWord=${this.search}`
    //   ,{
    //     headers:headers
    //   });
    // console.log(factories.data.data.content);
    //   this.factoriesList = factories.data.data.content;
    // },
    // async callFactoriesId() {
    //   const factory = await axios.get(
    //     process.env.VUE_APP_API_URL +
    //       `/getFactory?id=${modelMandatory.value.facId}`
    //   ,{
    //     headers:headers
    //   });
    // console.log(factory.data.data);
    //   this.factory = factory.data.data.content[0];
    //   this.search = this.factory["factoryName"];
    //   this.callFactories();
    // },
    setBuildingTypes(id) {
      if (
        modelMandatory.value &&
        modelMandatory.value.buildingTypes.length > 0
      ) {
        for (const loopdata of modelMandatory.value.buildingTypes) {
          if (loopdata["buildingTypeId"] == id) {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    fileMultipleClick() {
      // console.log(this.$refs.fileMultiple);
      const input: any = this.$refs.fileMultiple;
      input.click();
    },
    fileAvatarClick() {
      // console.log(this.$refs.fileAvatar);
      const input: any = this.$refs.fileAvatar;
      input.click();
    },
    fileClick() {
      // console.log(this.$refs.file);
      const input: any = this.$refs.file;
      input.click();
    },
    renderCategory(list) {
      let data: any = [];
      if (list.length > 0) {
        for (const looplist of list) {
          data.push(looplist[0].data);
        }
      }
      if (data.length > 0) {
        return data.join(",");
      } else {
        return "-";
      }
    },
    renderStatus(status) {
      if (status == 1 || status == 2) {
        return "<span style='color:#9999D3'>เรียนต่อ</span>";
      } else if (status == 3) {
        return "<span style='color:#31B67C'>เรียนจบ</span>";
      } else if (status == 4) {
        return "<span style='color:#FF7786'>ไม่ผ่านหลักสูตร</span>";
      } else if (status == 5) {
        return "<span style='color:#F2A17D'>หมดเวลาเรียน</span>";
      } else {
        return "-";
      }
    },
    handleData1(data) {
      this.rate1 = data;
    },
    handleData2(data) {
      this.rate2 = data;
    },
    handleData3(data) {
      this.rate3 = data;
    },
    handleData4(data) {
      this.rate4 = data;
    },
    async setId(id) {
      this.rateId = id;
      this.rate1 = 0;
      this.rate2 = 0;
      this.rate3 = 0;
      this.rate4 = 0;
    },
    async sentScore() {
      const formData = new FormData();
      formData.append("id", this.rateId + "");
      formData.append("rate1", this.rate1 + "");
      formData.append("rate2", this.rate2 + "");
      formData.append("rate3", this.rate3 + "");
      formData.append("rate4", this.rate4 + "");
      formData.append("remark", "");

      await axios
        .post(process.env.VUE_APP_API_URL + "/updateCourseRate", formData, {
          headers: { token: localStorage.getItem("id_token") },
        })
        .then((res) => {
          if (res.data.code == 200) {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function() {
              router.go(0);
            });
          } else {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    onBack() {
      this.$router.go(-1);
    },
    showForm(data) {
      this.formpassword = data;
    },
    validatePassword() {
      this.validate = 0;
      const letterRegex = /[a-zA-Z]/;
      const numberRegex = /[0-9]/;
      const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/;

      const isValidLength = this.newPassword.length >= 8;
      const hasLetter = letterRegex.test(this.newPassword);
      const hasNumber = numberRegex.test(this.newPassword);
      const hasSymbol = symbolRegex.test(this.newPassword);

      if (isValidLength) {
        this.validate = this.validate + 1;
      }
      if (hasLetter) {
        this.validate = this.validate + 1;
      }
      if (hasNumber) {
        this.validate = this.validate + 1;
      }
      if (hasSymbol) {
        this.validate = this.validate + 1;
      }
      // console.log("validatePassword");
      // console.log(this.validate);
      // return isValidLength && hasLetter && hasNumber && hasSymbol;
    },
    validateConfirmpassword() {
      if (this.newPassword == this.newPasswordConfirm) {
        this.validateCpassword = true;
      } else {
        this.validateCpassword = false;
      }
    },
    async changePassword() {
      const formData = new FormData();
      formData.append("oldPassword", this.oldPassword);
      formData.append("newPassword", this.newPassword);
      formData.append("newPasswordConfirm", this.newPasswordConfirm);

      await axios
        .post(process.env.VUE_APP_API_URL + "/changeUserPassword", formData, {
          headers: { token: localStorage.getItem("id_token") },
        })
        .then((res) => {
          if (res.data.code == 200) {
            Swal.fire({
              title: "เปลี่ยนรหัสผ่านสำเร็จ",
              text: "รหัสผ่านถูกเปลี่ยนแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(() => {
              this.oldPassword = "";
              this.newPassword = "";
              this.newPasswordConfirm = "";
              this.formpassword = false;
            });
          } else {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    onBaclk() {
      this.$router.go(-1);
    },
    setRemarkDelete(event) {
      this.remarkDeleteUser = event.target.value;
    },
    submitDelete() {
      axios
        .delete(
          process.env.VUE_APP_API_URL +
            `/deleteProfileByUser?deleteRemarkId=${this.remarkDeleteUser}&deleteRemarkOth=${this.remarkDeleteOther}`,
          {
            headers: { token: localStorage.getItem("id_token") },
          },
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.dialogDeletePopup = false;
            this.dialogDeleteConfirmed = false;
            this.dialogDeleteUser = false;
            this.dialogDeletePdpa = false;
            this.dialogError = false;
            this.dialogSurvey = false;
            Swal.fire({
              title: "การลบบัญชีผู้ใช้งานสำเร็จ",
              text: "",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-primary",
              },
            }).then((res) => {
              const preserveKeys = ["timer", ...Object.keys(localStorage).filter(k => k.startsWith("ExamQuestion_") || k.startsWith("ExamLearnQuestion_") || k.startsWith("examLearnAnswersList_") || k.startsWith("ExamAnswersList_"))];
              const preserved = preserveKeys.map(k => [k, localStorage.getItem(k) ?? ""]);
              localStorage.clear();
              preserved.forEach(([k, v]) => { if (v) localStorage.setItem(k, v); });
              router.push({ name: "sign-in" });
            });
          } else {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    deleteActivity() {
      Swal.fire({
        title: "แจ้งเตือน",
        text: "ต้องลบข้อมูลการลงทะเบียนเรียนทั้งหมดใช่หรือไม่ !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#323563",
        cancelButtonColor: "#ff7786",
        allowOutsideClick: false,
        confirmButtonText: "ใช่",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(process.env.VUE_APP_API_URL + "/deleteActivity", {
              headers: {
                token: localStorage.getItem("id_token"),
              },
            })
            .then((res) => {
              if (res.data.code == 200) {
                Swal.fire({
                  title: "ลบข้อมูลการลงทะเบียนเรียนสำเร็จ",
                  text: "",
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "ตกลง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-app-primary",
                  },
                }).then((res) => {
                  this.$router.go(0);
                });
              } else {
                Swal.fire({
                  title: "แจ้งเตือนข้อผิดพลาด",
                  text: res.data.message,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-danger",
                  },
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: error.response.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        }
      });
    },
    dateDifference(startDate, endDate) {
      let start: any = new Date(startDate);
      let end: any = new Date(endDate);

      var difference = Math.abs(end - start) / 1000;
      // Calculate minutes and seconds
      var minutes = Math.floor(difference / 60);
      var seconds = Math.floor(difference % 60);

      // Format minutes and seconds
      var formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      var formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

      return formattedMinutes + ":" + formattedSeconds;
    },
  },
  async mounted() {
    // if (localStorage.getItem("reloaded")) {
    //   location.reload();
    //   localStorage.removeItem("reloaded");
    // }
    Swal.fire({
      title: "กำลังโหลดข้อมูล",
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const qualifications = await axios.get(
        process.env.VUE_APP_API_URL + "/getQualification",
      );
      this.qualificationList = qualifications.data.data;

      const officeTypes = await axios.get(
        process.env.VUE_APP_API_URL + "/getOfficeType",
      );
      this.officeTypeList = officeTypes.data.data;
      const buildingSizes = await axios.get(
        process.env.VUE_APP_API_URL + "/getBuildingSize",
      );
      this.buildingSizesList = buildingSizes.data.data;

      const buildingTypes = await axios.get(
        process.env.VUE_APP_API_URL + "/getBuildingTypes",
      );
      this.buildingTypesList = buildingTypes.data.data;

      const factorySizes = await axios.get(
        process.env.VUE_APP_API_URL + "/getFactorySize",
      );
      this.factorySizesList = factorySizes.data.data;

      const factoryTypes = await axios.get(
        process.env.VUE_APP_API_URL + "/getFactoryTypes",
      );
      this.factoryTypesList = factoryTypes.data.data;

      const technologies = await axios.get(
        process.env.VUE_APP_API_URL + "/getTechnologies",
      );
      this.technologiesList = technologies.data.data;

      const machines = await axios.get(
        process.env.VUE_APP_API_URL + "/getMachines",
      );
      this.machinesList = machines.data.data;

      const factoryBuildingTypes = await axios.get(
        process.env.VUE_APP_API_URL + "/getFactoryBuildingTypes",
      );
      this.factoryBuildingTypesList = factoryBuildingTypes.data.data;
      setTimeout(() => {
        if (modelMandatory.value.facId) {
          this.callFactoriesId();
        }
      }, 1000);

      try {
        let response = await ReferenceDataApi.getPrenames();
        this.prefixList = response.data.data;
      } catch (error) {
        (this.listErrorApi as any).push({
          api: process.env.VUE_APP_API_URL + "/getReferencePrenames",
          message: "ไม่สามารถเชื่อมต่อกับฐานข้อมูล กพบ ได้ในขณะนี้",
        });
      }
      try {
        let response = await ReferenceDataApi.getRegions();
        this.regionList = response.data.data;
      } catch (error) {
        (this.listErrorApi as any).push({
          api: process.env.VUE_APP_API_URL + "/getReferenceRegions",
          message: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
        });
      }

      try {
        if (
          modelEdit.value.regionId &&
          this.regionList &&
          this.regionList.length > 0
        ) {
          await this.callProvince(modelEdit.value.regionId, false);
        }
        if (
          modelEdit.value.provinceId &&
          this.provinceList &&
          this.provinceList.length > 0
        ) {
          await this.callDistrict(modelEdit.value.provinceId, false);
        }
        if (
          modelEdit.value.districtId &&
          this.districtList &&
          this.districtList.length > 0
        ) {
          await this.callSubDistrict(modelEdit.value.districtId, false);
        }
        if (
          modelEdit.value.subDistrictId &&
          this.subDistrictList &&
          this.subDistrictList.length > 0
        ) {
          await this.callZipcode(modelEdit.value.subDistrictId, false);
        }
      } catch (error) {
        (this.listErrorApi as any).push({
          api: process.env.VUE_APP_API_URL + "/getReferenceProvinces",
          message: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
        });
      }

      if (this.listErrorApi && this.listErrorApi.length > 0) {
        dialogError.value = true;
      } else {
        dialogError.value = false;
      }
    } catch (error) {
      (this.listErrorApi as any).push({
        api: process.env.VUE_APP_API_URL,
        message: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
      });
      dialogError.value = true;
    } finally {
      Swal.close();
    }
  },
  beforeUnmount() {
    this.listErrorApi = [];
    dialogError.value = false;
    Swal.close();
  },
});
